<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner-list">
        <div class="row">
            <div class="col-sm-6">
                <h1 class="title-default">Resulth Scanntech</h1>
            </div>
        </div>

        <!-- Info: funcionalidade disponível apenas para Resulth -->
        <div class="info-banner">
            <mat-icon class="info-icon">info_outline</mat-icon>
            <div class="info-content">
                <strong>Atenção:</strong> Esta integração funciona somente para o <strong>Resulth</strong>.
                Caso utilize outro sistema, esta funcionalidade não estará disponível.
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12">
                <h2 class="subtitle-default">Promoções Ativas</h2>
            </div>
        </div>

        @if(this._listaPromocaoResponse && this._listaPromocaoResponse.listaPromocao.length > 0){
        <table mat-table [dataSource]="_listaPromocaoResponse.listaPromocao">
            <ng-container matColumnDef="codigo">
                <th mat-header-cell *matHeaderCellDef> Código </th>
                <td mat-cell *matCellDef="let element"> {{element.idPromocaoScanntech}} </td>
            </ng-container>

            <ng-container matColumnDef="descricao">
                <th mat-header-cell *matHeaderCellDef> Descrição </th>
                <td mat-cell *matCellDef="let element"> {{element.descricao}} </td>
            </ng-container>

            <ng-container matColumnDef="tipo">
                <th mat-header-cell *matHeaderCellDef> Tipo </th>
                <td mat-cell *matCellDef="let element"> {{element.idTipoPromocao}} </td>
            </ng-container>

            <ng-container matColumnDef="dataInicial">
                <th mat-header-cell *matHeaderCellDef> Data inicial </th>
                <td mat-cell *matCellDef="let element"> {{element.dataInicio | date:'dd/MM/yyyy'}} </td>
            </ng-container>

            <ng-container matColumnDef="dataFinal">
                <th mat-header-cell *matHeaderCellDef> Data final </th>
                <td mat-cell *matCellDef="let element"> {{element.dataFim | date:'dd/MM/yyyy'}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        }@else if(_isLoading === true){
        <app-loading-box-default-list></app-loading-box-default-list>
        }
        @else if(this._listaPromocaoResponse?.listaPromocao?.length === 0){
        <app-empty-list [title]="'Não foi encontrada nenhuma promoção ativa'"></app-empty-list>
        }

        <div class="d-flex justify-content-end mt-3 gap-3">
            <a type="button" mat-button class="btn-secondary btn-add-right"
                routerLink="/integracao/resulth-scanntech/configurar">
                Configuração
            </a>
            <a type="button" mat-flat-button class="btn-primary btn-add-right"
                routerLink="/integracao/resulth-scanntech/dados-integracao">
                Dados da Integração
            </a>
            <a type="button" mat-flat-button class="btn-primary btn-add-right"
                routerLink="/integracao/resulth-scanntech/relatorio">
                Relatório
            </a>
        </div>
    </div>
</div>
